import React from 'react'
import { Alert, Button, Layout } from 'antd'
import { connect, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { push } from 'connected-react-router'
import { FormattedMessage, injectIntl, useIntl } from 'react-intl'
import { isEmpty } from 'lodash-es'
import classNames from 'classnames'
import NProgress from 'nprogress'
import Icon from 'components/Icon'
import TopBar from 'components/LayoutComponents/TopBar'
import Menu from 'components/LayoutComponents/Menu'
import Footer from 'components/LayoutComponents/Footer'
import Breadcrumbs from 'components/LayoutComponents/Breadcrumbs'
import AccountTransactionModal from 'containers/Reports/AccountTransactions/AccountTransactionModal'
import FinanceOnboarding from 'containers/FinanceOnboarding'
import BroadcastModal from 'containers/Broadcast'
import NPS from 'containers/NPS'
import { Welcome } from 'containers/ProductTour'
import LoginModal from 'pages/user/login/LoginModal'
import NoInternetModal from 'components/UI/NoInternetModal'
import AppLoading from 'components/UI/AppLoading'
import { inits } from 'app-redux/actions'
import { showBroadcast } from 'app-redux/broadcast/actions'
import { setSelectedEndpoint } from 'app-redux/companies/actions'
import { resetDashboard } from 'app-redux/finance/actions'
import { startInhouseChat, stopInhouseChat } from 'utils/inhouseChat'
import Scrollbars from 'react-custom-scrollbars-2'
import AuditByTransType from 'containers/Audit/AuditByTranstype'
import LivestreamThumbnail from 'components/apps/livestream/LivestreamThumbnail'
import LivestreamAlert from 'components/apps/livestream/LivestreamAlert'
import MarketplaceConnectionAlert from 'components/apps/Marketplace/MarketplaceConnectionAlert'
import Banner from 'components/apps/Banner'
import { billingSelector } from 'app-redux/selectors'
import { isFinanceOnboardingActive } from 'app-redux/financeOnboardingSlice'
import GlobalSearch from '@/components/apps/GlobalSearch'
import AppOnboardingNotificationContainer from '@/containers/FinanceInvoices/AppOnboardingNotification'
import LowStockBanner from '@/components/apps/FinanceInvoices/LowStockBanner'
import PushNotificationPrompt from './PushNotificationPrompt'

const ClickHere = () => {
  const { formatMessage } = useIntl()
  const billing = useSelector(billingSelector)

  return (
    <Link
      to={`/settings/billing/${
        billing.can_be_addoned ? 'addon' : billing.can_be_upgraded ? 'upgrade' : 'upgrade?isRenew=1'
      }`}
      className="text-primary"
    >
      {formatMessage({ id: 'billing.here' })}
    </Link>
  )
}

const mapStateToProps = ({
  settings,
  _inits: {
    user: { id, is_superuser: isSuperUser, email },
    livestream,
    show_nps: showNps,
    announcement,
    banner,
  },
  inits: { loading, loadedInit, attemp },
  options: { options },
  companies: { endpoint: companyEndpoint },
  billing,
  broadcast: { data: broadcast, show: isShowBroadCast },
  translation,
  maintenance,
  loginForm: { showLoginForm },
  network: { showNoInternetModal },
  finance: {
    auditModal: { show: isShowAudit },
    accountTransactionReport: { show: isShowAccountTransaction },
  },
  router: { location },
}) => ({
  darkMode: options.dark_mode,
  isBorderless: settings.isBorderless,
  isSquaredBorders: settings.isSquaredBorders,
  isFixedWidth: settings.isFixedWidth,
  isMenuShadow: settings.isMenuShadow,
  isMenuTop: settings.isMenuTop,
  isMobileView: settings.isMobileView,
  id,
  isSuperUser,
  loading,
  companyEndpoint,
  isExpired: billing.is_expired,
  isInvoiceQuotaExceeded: billing.is_invoice_quota_exceeded,
  isInvoiceQuotaAlmostFull: billing.is_invoice_quota_almost_full,
  isFinanceOnboarding: isFinanceOnboardingActive(options.finance_onboarding),
  isProductTour: options.product_tour && !isFinanceOnboardingActive(options.finance_onboarding),
  notificationShowNpsMute: options.notification_show_nps_mute,
  broadcast,
  loadedInit,
  attemp,
  translation,
  announcement,
  maintenance,
  email,
  showLoginForm,
  showNoInternetModal,
  livestream,
  showNps,
  isShowBroadCast,
  isShowAudit,
  isShowAccountTransaction,
  isShowWebinar: options.notification_webinar === 1,
  banner,
  location,
})

const mapDispatchToProps = (dispatch) => {
  return {
    onInits: () => dispatch(inits()),
    onShowBroadcast: () => dispatch(showBroadcast()),
    push: (path) => dispatch(push(path)),
    onChangeCompany: (payload, callback) => {
      dispatch(resetDashboard())
      dispatch(setSelectedEndpoint(payload))
      if (typeof callback === 'function') {
        callback()
      }
    },
  }
}

class MainLayout extends React.PureComponent {
  scrollBarRef = React.createRef()

  constructor(props) {
    super(props)

    this.state = {
      showGlobalSearch: false,
    }
  }

  componentDidMount() {
    if (this.props.loadedInit) {
      startInhouseChat(this.props.companyEndpoint)
    }
    if (
      !this.props.id &&
      !this.props.loading &&
      this.props.attemp <= 4 &&
      isEmpty(this.props.maintenance)
    ) {
      this.props.onInits()
    }
  }

  componentDidUpdate(prevProps) {
    const { loadedInit, broadcast, onShowBroadcast, companyEndpoint } = this.props
    // Ganti company → inits dijalankan ulang (loadedInit false) → hapus widget dulu,
    // lalu tampilkan lagi setelah inits sukses.
    if (prevProps.loadedInit && !loadedInit) {
      stopInhouseChat()
    }
    if (!prevProps.loadedInit && loadedInit) {
      startInhouseChat(companyEndpoint)
    }
    if (prevProps.loadedInit !== loadedInit && loadedInit && !isEmpty(broadcast)) {
      onShowBroadcast()
    }
  }

  componentWillUnmount() {
    // Pindah ke layout lain (select company, cashier, dll.) → widget ikut dihapus.
    stopInhouseChat()
  }

  isDashboard = () => {
    return this.props.location.pathname === '/dashboard'
  }

  handleOpenGlobalSearch = () => {
    this.setState({ showGlobalSearch: true })
  }

  handleCloseGlobalSearch = () => {
    this.setState({ showGlobalSearch: false })
  }

  render() {
    const {
      children,
      isBorderless,
      isSquaredBorders,
      isFixedWidth,
      isMenuShadow,
      isMenuTop,
      loading,
      loadedInit,
      isExpired,
      isInvoiceQuotaExceeded,
      isInvoiceQuotaAlmostFull,
      isMobileView,
      intl,
      isProductTour,
      companies,
      onChangeCompany,
      isSuperUser,
      translation,
      push: onPush,
      announcement,
      darkMode,
      showLoginForm,
      showNoInternetModal,
      showNps,
      isShowBroadCast,
      isShowAudit,
      isShowAccountTransaction,
      isShowWebinar,
      livestream,
      banner,
      notificationShowNpsMute,
    } = this.props

    // Tampilkan halaman loading saat hit /inits sebelum data init siap di redux
    // (login single-company / verifikasi token / pilih perusahaan / refresh).
    // Pakai `loading && !loadedInit` agar tidak menutupi dashboard saat aksi lain
    // memicu `loading` (mis. simpan setting) maupun halaman /server-error saat gagal.
    if (loading && !loadedInit) {
      return <AppLoading />
    }

    if (loading) {
      NProgress.start()
    } else {
      NProgress.done()
    }

    let styleCustom = {}
    if (this.isDashboard()) {
      styleCustom = {
        style: {
          paddingLeft: 0,
          paddingRight: 0,
          paddingTop: 0,
        },
      }
    }

    return (
      <>
        <Layout
          className={classNames({
            settings__borderLess: isBorderless,
            settings__squaredBorders: isSquaredBorders,
            settings__fixedWidth: isFixedWidth,
            settings__menuShadow: isMenuShadow,
            settings__menuTop: isMenuTop,
          })}
        >
          <Menu scrollBarRef={this.scrollBarRef} />
          <Scrollbars style={{ height: '100vh' }} autoHide>
            <Layout style={{ position: 'relative' }} id="scrollable-container">
              {livestream?.is_live === '1' && !livestream?.is_show_thumbnail && !isMobileView && (
                <LivestreamAlert />
              )}
              {!isEmpty(announcement) && (
                <Alert
                  className="alert-warning-highlight"
                  message={announcement}
                  type="warning"
                  showIcon
                  closable
                />
              )}
              {isExpired && (
                <Alert
                  className="alert-warning-highlight"
                  message={
                    <FormattedMessage
                      id="billing.expired"
                      values={{
                        setup: (
                          <Link to="/settings/billing/upgrade">
                            <strong>
                              <FormattedMessage id="billing.expired_link" />
                            </strong>
                          </Link>
                        ),
                      }}
                    />
                  }
                  type="warning"
                  showIcon
                />
              )}
              {isInvoiceQuotaExceeded || isInvoiceQuotaAlmostFull ? (
                <Alert
                  className="alert-warning-highlight"
                  message={
                    <FormattedMessage
                      id={
                        isInvoiceQuotaExceeded
                          ? 'billing.is_invoice_quota_exceeded'
                          : 'billing.is_invoice_quota_almost_full'
                      }
                      values={{ here: <ClickHere /> }}
                    />
                  }
                  type="warning"
                  showIcon
                />
              ) : null}
              <MarketplaceConnectionAlert />

              <Layout.Header>
                <TopBar
                  push={onPush}
                  isSuperUser={isSuperUser}
                  companies={companies}
                  translation={translation}
                  onChangeCompany={onChangeCompany}
                  isMobileView={isMobileView}
                  darkMode={darkMode}
                  onOpenGlobalSearch={this.handleOpenGlobalSearch}
                />
              </Layout.Header>
              {isMobileView && (
                <div style={{ paddingLeft: 16, paddingRight: 16, paddingTop: 8 }}>
                  <Button block icon={<Icon name="search" />} onClick={this.handleOpenGlobalSearch}>
                    {intl.formatMessage({ id: 'search' })}
                  </Button>
                </div>
              )}
              <Layout.Content>
                {!isMobileView && <Breadcrumbs />}
                <div className="utils__content" {...styleCustom}>
                  <div className="low-stock-promo-row">
                    {loadedInit && <PushNotificationPrompt />}
                    <AppOnboardingNotificationContainer />
                    <LowStockBanner />
                  </div>
                  {children}
                </div>
              </Layout.Content>
              <Layout.Footer>
                <Footer />
              </Layout.Footer>
            </Layout>
          </Scrollbars>
        </Layout>
        {livestream?.is_live === '1' && livestream?.is_show_thumbnail && (
          <LivestreamThumbnail isChatSupportShowed />
        )}
        {!!showNps && <NPS muteDuration={notificationShowNpsMute} showNps={showNps} />}
        {isShowAccountTransaction && <AccountTransactionModal />}
        {isShowAudit && <AuditByTransType />}
        {isShowBroadCast && <BroadcastModal />}
        {isProductTour && <Welcome scrollBarRef={this.scrollBarRef} />}
        {this.props.isFinanceOnboarding && <FinanceOnboarding />}
        {showNoInternetModal && <NoInternetModal />}
        {showLoginForm && !showNoInternetModal && <LoginModal />}
        {isShowWebinar && !isEmpty(banner) && !this.props.isFinanceOnboarding && (
          <Banner banner={banner} />
        )}
        {this.state.showGlobalSearch && (
          <GlobalSearch
            open={this.state.showGlobalSearch}
            onCancel={this.handleCloseGlobalSearch}
          />
        )}
      </>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(MainLayout))
